export default {
  label: {
    title: 'Import file',
    file: 'File',
    insertFile: 'Select the document',
    cancel: 'Cancel',
    ok: 'Ok',
    send: 'Send',
    clear: 'Clear',
    requiredValue: 'Required value',
    processed: 'Spreadsheet successfully uploaded',
    status: 'Status: ',
    totalPosts: 'Total Publications: ',
    dataStorageUrl: 'Processed spreadsheet link: ',
    errorMessage: 'Error description: ',
  },

  infoLabel: 'Form Information',
  closeLabel: 'Close Information',

  upload: {
    error: 'There are errors in the posts in the spreadsheet, please check the data and try again.',
    success: 'Spreadsheet successfully uploaded',
  },

  faq: {
    title: 'What is the format of the spreadsheet?',
    description: 'The spreadsheet must be in xlsx format.',
  },
  faq2: {
    title: 'What is the correct formatting for the spreadsheet?',
    description: 'This component requires a spreadsheet owned by Stilingue, hosted on Google Sheets.',
  },
  faq3: {
    title: 'How can I know if my data has been imported?',
    description: 'The result of the import will be sent via email.',
  },
};
